import { InvoiceStatus } from '@enums/invoice-status.enum';

export const INVOICE_STATUS_LABEL: Record<InvoiceStatus, string> = {
  [InvoiceStatus.sent]: 'Envoyée',
  [InvoiceStatus.draft]: 'Brouillon',
  [InvoiceStatus.saved]: 'Facturée',
  [InvoiceStatus.paid]: 'Payée',
  [InvoiceStatus.cancelled]: 'Annulée'
};
